import { useEffect, useState } from 'react';

const imageCache = new Map();

export function useCachedImage(url) {
	const [image, setImage] = useState(null);

	useEffect(() => {
		if (!url) {
			setImage(null);
			return;
		}

		if (imageCache.has(url)) {
			setImage(imageCache.get(url));
			return;
		}

		const fetchImage = async () => {
			try {
				const response = await fetch(url);
				const blob = await response.blob();

				const reader = new FileReader();
				reader.onloadend = () => {
					const base64 = reader.result;
					imageCache.set(url, base64);
					setImage(base64);
				};
				reader.readAsDataURL(blob);
			} catch (err) {
				console.error('Failed to fetch image:', err);
				setImage(null);
			}
		};

		fetchImage();
	}, [url]);

	return image;
}
